(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name greatCircleDistance.controller:GreatCircleDistanceCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('flightCargo')
		.controller('FlightCargoCtrl', FlightCargoCtrl);

	function FlightCargoCtrl(CommonMasterData, EventManagerService, FlightCargoService, MessageService, $timeout, $window, FlightCargoFactory) {
		var vm = this;
		var rowHeight = 50;
		vm.showRightPanel = false;
		vm.flightListToSave = [];
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				flightNumber : "",
				arrival : {value : undefined, required:false},
				departure : {value : undefined, required:false},
				fromDate : moment(new Date()).format('DD/MM/YYYY'),
        toDate : moment(new Date()).format('DD/MM/YYYY'),
        cargoWeightAvailable :'B',
				pageSize : Math.ceil(screen.height / rowHeight) * 3,
				startPosition : 1,
			},
			masterList : {
				airportList : [],
        cargoWeightAvailable : FlightCargoService.getSearchCargoWeight(),
				// 70 (title bar height) + 40 (toolbar height)+ 47 (table header)
				canvasHeight : $window.innerHeight - 157,
				//70 (Side panel)
				canvasWidth : $window.innerWidth - 70,
				fromDateFormatInvalid : false
			},
			flightCargoData : []
		};

		angular.element($window).bind('resize', function(){
            $timeout(function () {
            	vm.model.masterList.canvasHeight = $window.innerHeight - 157;
            	vm.model.masterList.canvasWidth = $window.innerWidth - 70;
            },0);
        });

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.submitSearch = function(searchParams) {
			vm.model.searchCriteria = searchParams;
			vm.model.searchCriteria.startPosition = 1;
			getFlightList();
		};

		// load grid data
		function getFlightList() {
			document.querySelector('.flight-cargo-elastic-div').scrollTop = 0;
			FlightCargoService.searchFlightCargoList(vm.model.searchCriteria, function(flightCargoData) {
				vm.model.flightCargoData = FlightCargoFactory.getFormattedFlights(flightCargoData);
				vm.model.searchPanelToggle = false;
			}, function(error) {
				MessageService.error(error);
			});
		};

		vm.saveFlightCargoDetails = function() {
			if(vm.flightListToSave.length <= 0) {
				MessageService.warning("No rows are updated");
				return;
			}
			var requestParams = {};
			requestParams.flightCargoDTOS = vm.flightListToSave;
			FlightCargoService.updateFlightCargoList(requestParams, function(response) {
				if(response.success) {
					vm.flightListToSave = [];
					getFlightList();
					MessageService.success("Cargo weight updated successfully  ");
				}
			}, function(error) {
				MessageService.error(error);
			});
		}

		vm.changeEditorField = function(searchParams,flag) {
			if (flag === 'fromDate') {
        if (!moment(searchParams.fromDate, "DD/MM/YYYY").isValid() && !!searchParams.fromDate) {
          vm.model.masterList.fromDateFormatInvalid = true;
        } else {
          vm.model.masterList.fromDateFormatInvalid = false;
        }
      }else if (flag === 'toDate') {
        if (!moment(searchParams.toDate, "DD/MM/YYYY").isValid() && !!searchParams.toDate) {
          vm.model.masterList.toDateFormatInvalid = true;
        } else {
          vm.model.masterList.toDateFormatInvalid = false;
        }
      }
		}

    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate + " "
        + vm.model.searchCriteria.fromTime,
        "DD/MM/YYYY HH:mm").isBefore(
        moment(vm.model.searchCriteria.toDate + " "
          + vm.model.searchCriteria.toTime,
          "DD/MM/YYYY HH:mm"));
    }

		vm.resetFlightCargoDetails = function() {
			if(vm.flightListToSave.length == 0) {
				MessageService.warning("No rows are updated");
				return;
			}
			angular.forEach(vm.model.flightCargoData.flightCargoDTOs, function(flight){
				var foundIndex = _.findIndex(vm.flightListToSave, {flightLegId: flight.flightLegId});
				if(flight.isChanged && foundIndex >= 0) {
					flight.cargoWeight = flight.orgCargoWeight;
					flight.isChanged = false;
				}
			})
			vm.flightListToSave = [];
		}

		vm.updateFlightCargoList = function(selectedRowData) {
			selectedRowData.isChanged = true;
			var foundIndex = _.findIndex(vm.flightListToSave, {flightLegId: selectedRowData.flightLegId});
			if(foundIndex < 0) {
				vm.flightListToSave.push(selectedRowData);
			} else {
        if ((selectedRowData.cargoWeight < 0) || (selectedRowData.cargoWeight == -0)) {
          vm.flightListToSave[foundIndex].cargoWeight = null;
        } else {
          vm.flightListToSave[foundIndex].cargoWeight = selectedRowData.cargoWeight;
        }
      }
		};
 function getNextSetOfRecords() {
			if (vm.model.flightCargoData &&
	                vm.model.flightCargoData.totalRecords &&
	                vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize < vm.model.flightCargoData.totalRecords
	            ) {
	                vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
	                getDataForElasticSearch();
	            }
			else {
				var lastPageStartPos = vm.model.flightCargoData.totalRecords - vm.model.searchCriteria.pageSize;
                if (vm.model.searchCriteria.startPosition < lastPageStartPos) {
                    vm.model.searchCriteria.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}

		function getDataForElasticSearch() {
			FlightCargoService.searchFlightCargoList(vm.model.searchCriteria, function(newFlightCargoData) {
				FlightCargoService.appendToGridFlightList(vm.model.flightCargoData, FlightCargoFactory.getFormattedFlights(newFlightCargoData));
			}, function(error) {
				MessageService.error(error);
			});

		}


		(function() {

			// Origing and destination list
			CommonMasterData.getAirportList(function (airportList) {
                vm.model.masterList.airportList = airportList;
            }, function (error) {})

		})();
	}
}());
